// extracted by mini-css-extract-plugin
export default {"container":"AwfXKudavZ4SclagreEA"};